var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PopImageComponent"},[_c('v-img',{staticClass:"zoom show",attrs:{"aspect-ratio":_vm.square ? 1 : '',"height":_vm.height,"src":_vm.image,"content-class":"insideBanner"}},[_c('div',{staticClass:"overlay"}),_c('div',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }